import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardService } from './dashboard.service';
import { DashboardLayoutService } from './dashboard-layout.service';
import { WidgetAdapterService } from './widget-adapter.service';
import { ChartService } from './chart.service';

/**
 * Dashboard module that provides all dashboard-related services
 * Use this module to ensure all dashboard services are properly provided
 */
@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    DashboardService,
    DashboardLayoutService,
    WidgetAdapterService,
    ChartService
  ],
  exports: []
})
export class DashboardModule {
  /**
   * The dashboard module provides 3 main services:
   * 
   * 1. DashboardService - Main service for dashboard operations
   *    - CRUD operations for dashboards
   *    - Widget management
   *    - Dashboard selection and persistence
   * 
   * 2. WidgetAdapterService - Handles widget configuration and conversion
   *    - Converts between different DTO formats
   *    - Provides default data and widget configurations
   * 
   * 3. DashboardLayoutService - Manages dashboard layouts
   *    - Provides default layouts
   *    - Layout CRUD operations
   * 
   * Plus:
   * - Widget-specific data sources in the data/ subdirectory
   *   Each widget type has its own data source file, exported via index.ts
   *   These are pure function-based sources rather than services
   */
} 